<template>
  <div class="chinese-report">
    <!-- 文字說明 -->
    <section class="border-b border-b--dashed pt-2 pb-3">
      <h3 class="print-color subtitle-border mb-3">{{ $t('findings') }} :</h3>
      <v-layout
        tag="ul"
        row
        wrap
        class="ml-2 chinese-report__group"
        v-if="getChineseReport.findings && Object.values(getChineseReport.findings).length"
      >
        <v-flex
          xs6
          sm4
          tag="li"
          v-for="(findingInfo, findingID, n) in getChineseReport.findings"
          :key="findingID"
          class="mb-1"
        >
          <h3 class="mb-1">{{ $t('finding') }}{{ n + 1 }}: {{ findingInfo.cName }}</h3>
          <ul v-if="findingInfo.records.length > 0">
            <li
              xs6
              md3
              tag="li"
              id="lesion"
              v-for="(record, recordsIndex) in findingInfo.records"
              :key="recordsIndex"
              class="mb-1"
            >
              <div v-for="(value, field) in record" :key="field">
                <p style="text-indent: 1em" v-if="value !== null && value !== ''">
                  <label
                    style="margin: 3px"
                    v-if="findingInfo.records.length > 1 && findingInfo.takeNote == 500"
                  >
                    病灶 {{ recordsIndex + 1 }}</label
                  >
                  <label style="margin-right: 3px">{{ field }}:</label>
                  <label> {{ value }}</label>
                </p>
              </div>
            </li>
          </ul>
        </v-flex>
      </v-layout>
      <div v-else class="ml-3">
        <h3>無</h3>
      </div>
    </section>
    <section class="border-b border-b--dashed pt-2 pb-3">
      <h3 class="print-color subtitle-border mb-3">{{ $t('procedureImages') }} :</h3>
      <div
        v-if="
          getChineseReport.findings &&
            (Object.values(getChineseReport.findings).length ||
              Object.values(getChineseReport.additionalImages).length)
        "
      >
        <div v-for="(findingInfo, findingID, n) in getChineseReport.findings" :key="findingID + n">
          <div v-if="findingInfo.images.length > 0" style="padding: 5px">
            <p>{{ $t('finding') }} {{ n + 1 }} :</p>
            <div class="flex xs12 report-img-arrange">
              <img
                :class="setImgArrangeCss(imgArrange)"
                v-for="(image, imageIndex) in findingInfo.images"
                :key="imageIndex"
                :src="prefixServerImgPath(`${examinationID}/${image}`)"
              />
            </div>
          </div>
        </div>

        <div
          v-if="
            getChineseReport.additionalImages &&
              !!Object.values(getChineseReport.additionalImages).length
          "
        >
          <p>{{ $t('additionalImage') }} :</p>
          <div class="report-img-arrange">
            <div
              v-for="(image, imageIndex) in getChineseReport.additionalImages"
              :key="imageIndex"
              :class="setImgArrangeCss(imgArrange)"
            >
              <img :src="prefixServerImgPath(`${examinationID}/${image.file}`)" />
              <p class="landmark" v-if="image.landmarkID != 0">
                {{ image.cName || image.enName || '' }}
              </p>
            </div>
          </div>
        </div>
        <div v-else class="ml-3">
          <h3>無</h3>
        </div>
      </div>

      <div v-else class="ml-3">
        <h3>無</h3>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const API_URL = process.env.VUE_APP_API_URL

export default {
  name: 'ChineseReport',
  props: {
    hasAdditionalImage: Boolean,
    imgArrange: Number,
    examinationID: String,
    examination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  created() {
    this.fetchChineseReport({
      examinationID: Number(this.examinationID),
      language: 'zh-tw',
    })
  },
  computed: {
    ...mapGetters('report', ['getChineseReport']),
  },
  methods: {
    ...mapActions('report', ['fetchChineseReport']),
    prefixServerImgPath(path) {
      return `${API_URL}/public/upload/image/${path}`
    },
    setImgArrangeCss(n) {
      return `screenshot${n}`
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/components/reportImgArrange.scss';
#lesion p {
  text-indent: 50px;
}
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
@media print {
  #lesion {
    text-indent: 50px;
    p {
      text-indent: 100px;
    }
  }
  .chinese-report__group li {
    flex-basis: 33%;
  }
}
</style>
